/**
 * File name: Buddypress JS file
 * @package WordPress
 * @subpackage Metafans
 * @since 1.0.0
 * * * Refactored to ES Modules architecture.
 * * Orchestrates feature modules located in ./bp/
 */

// --- Core & Legacy Imports ---
import { ActivityPostFormInit } from './bp/activity-form.js';
import { init as initMediaUploads } from './bp/activity-media.js';
import { init as initPostForm } from './bp/activity-post-form.js';
import { init as initVisibilityController } from './bp/activity-visibility-controller.js';
import { init as initBbpressEditor } from './bp/bbpress-editor.js';
import { ActivityEditController } from './bp/edit-controller.js';
import { init as bpInit } from './bp/index.js';
import { initProfile } from './bp/profile.js';
import { set as stateSet } from './bp/state.js';
import { toggleActivityPostFormPopup } from './bp/ui.js';
import { init as initUrlPreview } from './bp/url-preview.js';
import { initEmojiHandlers } from './emoji-handler.js';

// --- Feature Imports ---
import { init as initActivityActions } from './bp/activity-actions.js';
import { initComments } from './bp/comments.js';
import { init as initHeaderUI } from './bp/header-ui.js';
import { initInfiniteScroll } from './bp/infinite-scroll.js';
import { initSwiper } from './bp/media-swiper.js';
import { initMediaViewer } from './bp/media-viewer.js';
import { initReactions } from './bp/reactions.js';
import { initTabs } from './bp/tabs.js';
import { init as initTextFormatter } from './bp/text-formatter.js';
import { initUIEffects } from './bp/ui-effects.js';

// --- Legacy Support ---
// Maintain compatibility for inline scripts relying on this export
import { visibilityPostFormData as __visibilityPostFormData } from './bp/templates.js';
export const visibilityPostFormData = __visibilityPostFormData;

// --- DOM Ready Initialization ---
document.addEventListener('DOMContentLoaded', () => {

    // 1. Initialize Core Forms & Editors
    ActivityPostFormInit();
    initBbpressEditor();
    initPostForm();
    initTextFormatter();
    initEmojiHandlers();
    initProfile();

    // 2. Initialize UI & Layout Controllers
    initHeaderUI();
    initTabs();
    initUIEffects();
    initVisibilityController();
    toggleActivityPostFormPopup();

    // 3. Initialize Interactive Features
    initActivityActions();
    initMediaViewer();
    initComments();
    initReactions();
    initMediaUploads();
    initUrlPreview();

    // 4. Initialize Media & Scrolling
    initSwiper();
    initInfiniteScroll();

    // 5. Initialize General BP Bootstrapper
    try {
        if (typeof bpInit === 'function') bpInit();
    } catch (err) {
        console.warn('BP Init failed safely:', err);
    }
});

// --- Window Load Initialization ---
// Heavy tasks deferred until full page load
window.addEventListener('load', () => {
    // Activity Edit Controller (Global Object)
    window.ActivityEditeControlerObject = new ActivityEditController();

    // Initialize State Constants
    stateSet('mf_activity_edite_is_delete_activity', false);
    stateSet('mf_activity_id_of_current_editeing_activity', false);
    stateSet('mf_activity_current_editing_activity_dom', false);
});